/**
 * Store pour la gestion d'un panier
 */

import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
/***/
import { useAuthUserStore } from '@stores/auth';
/***/
import axios from '@js/tools/axios';

export const useCartStore = defineStore('cart', (() => {

    // Store de l'utilisateur connecté
    const authUserStore = useAuthUserStore();

    // State de la liste des produits dans le panier
    const products = ref(null);

    // Retourne les produits dans le panier
    const getProducts = computed(() => products.value);

    /**
     * Retourne les produits du type en paramètre
     * @param int type
     * @return array
     */
    const getProductsByType = computed(() => {
        return ((type) => {
            const items = getProducts.value || [];

            return items.filter((product) => {
                return (product.type === type);
            });
        });
    });

    /**
     * Récupère la liste des produits dans le panier
     * @param bool force Vrai si on force le chargement des données
     * @param object params Données pour la requête (country notamment pour déterminer s'il faut comptabiliser la TVA)
     * @return Promise
     */
    const loadProducts = ((force = false, params = {}) => {

        if (products.value !== null && ! force) {
            return Promise.resolve();
        }

        return axios.get('/api/cart/products', {
            params: params
        }).then((response) => {
            if (response.data.success && response.data.products) {
                products.value = response.data.products;
                return Promise.resolve();
            }
            return Promise.reject();
        });

    });

    /**
     * Modifie la quantité du produit en paramètre dans le panier
     * @param Object product
     * @param int quantity
     * @param string affiliationCode
     * @return Promise
     */
    const updateProductQuantity = ((product, quantity, affiliationCode) => {

        const path = `/api/cart/products/${ product.id }/update-quantity`;

        return axios.post(path, {
            quantity: quantity,
            affiliationCode: affiliationCode
        }).then((response) => {
            if (response.data.success && response.data.products) {
                products.value = response.data.products;
                return Promise.resolve();
            }
            return Promise.reject();
        });

    });

    /**
     * Appel pour une intention de paiement
     * @param object params
     * @return Promise
     */
    const paymentIntent = ((params) => {

        return axios.post('/api/cart/payment-intent', params).then((response) => {
            if (response.data && response.data.success) {

                if(response.data.user) {
                    authUserStore.updateCurrentUserData(response.data.user);
                }

                if(response.data.paymentIntent) {
                    return Promise.resolve(response.data.paymentIntent);
                }
            }

            return Promise.reject();
        }).catch((response) => {
            let responseData = null;
            if(response && response.response && response.response.data) {
                responseData = response.response.data;
            }
            return Promise.reject(responseData);
        });

    });

    return {
        getProducts,
        getProductsByType,
        loadProducts,
        updateProductQuantity,
        paymentIntent
    };

}));
